import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Tooltip,
  Button,
} from "antd";
import { getRequest, patchRequest } from "../../axios";
import { Trans, useTranslation } from "react-i18next";
import { authUserData } from "../../utils/Helper";
import moment from "moment";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { t } from "i18next";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { Space, Table, Card } from "antd";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { FilterOutlined, UndoOutlined } from "@ant-design/icons";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";
const RfqPoConversionReport = () => {
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [detailsSource, setDetailsSource] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const formRef = useRef();
  const options = {
    chart: {
      id: "basic-bar",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    },
  };

  const series = [
    {
      name: "Series 1",
      data: [30, 40, 35, 50, 49, 60],
    },
  ];
  const [state, setState] = useState({
    page: 1,
    pagesize: 10,
  });
  useEffect(() => {
    const getReportData = async () => {
      setapiLoading(true);
      try {
        const response = await getRequest(
          `po-order/rfq-to-po-conversion-report/?company_id=${CompanyId}`,
          state
        );
        setDataSource(response.data.results.data);
        settotalCount(response.data.count);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getReportData();
  }, [reload, state, t]);

  const getSourceData = async (record) => {
    try {
      setDetailsSource(record?.po_description);
    } catch (error) {
      console.error("Error fetching approval data:", error);
    }
  };
  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      // width: 120,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      // width: 130,
    },
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      // width: 120
    },
    {
      title: "RFQ Date",
      dataIndex: "rfq_created_date",
      key: "rfq_created_date",
      // width: 120
    },
    {
      title: "Status",
      dataIndex: "rfq_status",
      key: "rfq_status",
      // width: 120
    },
  ];
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };

  const handlePdfDownload = async () => {
    // const worksheet = XLSX.utils.json_to_sheet(dataSource);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data');
    // XLSX.writeFile(workbook, `rfq_po_conversion_report${+new Date()}.xlsx`);

    /* PDF Download */
    const pdf = new jsPDF("p", "pt", "a4");
    const pdfColumns = [
      "Category",
      "Company Name",
      "RFQ Number",
      "RFQ Date",
      "Status",
    ];
    let rows = [];

    for (let i = 0; i < dataSource.length; i++) {
      let temp = [
        dataSource[i].category_tree_name,
        dataSource[i].company_name,
        dataSource[i].rfq_number,
        dataSource[i].rfq_created_date !== null
          ? dataSource[i].rfq_created_date
          : "",
        dataSource[i].rfq_status,
      ];
      rows.push(temp);
    }
    pdf.text(200, 40, "RFQ to PO Conversion Report");
    pdf.autoTable(pdfColumns, rows, {
      startY: 65,
      theme: "grid",
      styles: {
        font: "times",
        halign: "center",
        overflow: "linebreak",
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [255, 255, 255],
        fontStyle: "normal",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: [9, 78, 143],
      },
      alternateRowStyles: {
        fillColor: [212, 212, 212],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
    });
    pdf.save(`rfq_po_conversion_report${+new Date()}`);
  };

  const handleReset = () => {
    setEndDate("");
    setStartDate("");
    setClickedFilterButton(false);
    setState({
      page: 1,
      pagesize: 10,
    });
    formRef.current.setFieldsValue({
      po_created_date_gte: null,
      po_created_date_lte: null,
    });
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
  };
  const handleApplyFilter = () => {
    setClickedFilterButton(true);
    const filterParams = {
      ...state,
      rfq_created_date_gte: startDate,
      rfq_created_date_lte: endDate,
    };

    setState(filterParams);
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    //const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
    });
  };

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: "Item Description",
        dataIndex: "material_type_name",
        key: "material_type_name",
      },
      {
        title: "No. of bidders",
        dataIndex: "no_of_bidders",
        key: "no_of_bidders",
      },
      {
        title: "PO Number",
        dataIndex: "po_number",
        key: "po_number",
      },
      {
        title: "PO placed to (Supplier name)",
        dataIndex: "po_vendor_name",
        key: "po_vendor_name",
      },
      {
        title: "PO Date",
        dataIndex: "po_created_date",
        key: "po_created_date",
      },
      {
        title: "RFQ Qty.",
        dataIndex: "rfq_quantity",
        key: "rfq_quantity",
      },
      {
        title: "RFQ to PO Days",
        dataIndex: "rfq_to_po_days",
        key: "rfq_to_po_days",
      },
      {
        title: "PO Status",
        dataIndex: "po_status",
        key: "po_status",
      },
    ];

    return (
      <Table
        scroll={{
          // y: 400,
          x: 1000,
        }}
        className="subtbl"
        columns={columns}
        dataSource={detailsSource}
        pagination={false}
        // loading={loading}
      />
    );
  };

  const handleExpand = async (expanded, record, index) => {
    if (expanded) {
      setDetailsSource([]);
      await getSourceData(record);
      setExpandedRowKeys([index]);
    } else {
      setExpandedRowKeys([]);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Visualize Item , State, City and Date wise specific
                  procurement data using charts and graphs for easier
                  interpretation and analysis.
                </span>
              }
            >
              <h3>RFQ to PO Conversion Report</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Reports</Breadcrumb.Item>
              <Breadcrumb.Item> RFQ to PO Conversion Report</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>


        <section className="grid-sec tablegridsec">
          <div className="PR-body">
          {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
            <div className="filterrow">
              <div className="filtercol">
                <Form autoComplete="off" ref={formRef}>
                  <Space wrap>
                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="rfq_created_date_gte">
                        <DatePicker
                          format="DD-MM-YY"
                          allowClear={false}
                          placeholder="Select Start Date"
                          value={startDate}
                          // onChange={handleStartDateChange}
                          onChange={(value) => handleStartDateChange(value)}

                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} className="TextFeild gutter-row">
                      <Form.Item name="rfq_created_date_lte">
                        <DatePicker
                          format="DD-MM-YY"
                          allowClear={false}
                          placeholder="Select End Date"
                          value={endDate}
                          onChange={handleEndDateChange}
                        />
                      </Form.Item>
                    </Col>
                    <>
                      <Button
                        type="primary"
                        icon={
                          <Tooltip title="Apply" color="#094E8F">
                            <FilterOutlined style={{ fontSize: "20px" }} />
                          </Tooltip>
                        }
                        onClick={
                          startDate || endDate ? handleApplyFilter : null
                        }
                        style={{
                          backgroundColor: "#094e8f",
                          color: "#ffffff",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          borderRadius: "4px",
                        }}
                      />

                      <Button
                        htmlType="Reset"
                        type="primary"
                        icon={
                          <Tooltip title="Reset" color="#094E8F">
                            <UndoOutlined style={{ fontSize: "20px" }} />
                          </Tooltip>
                        }
                        onClick={
                          clickedFilterButton ? handleReset : handleClearFields
                        }
                        style={{
                          backgroundColor: "#094e8f",
                          color: "#ffffff",
                          border: "none",
                          width: "40px",
                          height: "40px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          borderRadius: "4px",
                        }}
                      />
                    </>
                  </Space>
                </Form>
              </div>
              <div className="btnscol">
                <Space>
                  {/* {endDate || startDate ? (
                    <>
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="Apply"
                        label="Apply"
                        onClick={handleApplyFilter}
                      />
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="Reset"
                        label="Reset"
                        onClick={handleReset}
                      />
                    </>
                  ) : (
                    ""
                  )} */}
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="PDF"
                    label="PDF"
                    onClick={handlePdfDownload}
                    icon={<img src={ExelDownload} alt="PDF Icon" />}
                  />
                </Space>
              </div>
            </div>
             <div className="tablewrp">
            {/* <Spin spinning={apiLoading}> */}
              <Table
                scroll={{
                  // y: 400,
                  x: 1000,
                }}
                columns={columns}
                dataSource={dataSource}
                rowKey={(record, index) => index}
                loading={apiLoading}
                pagination={{
                  defaultCurrent: state.page,
                  defaultPageSize: state.pagesize,
                  total: totalCount,
                  showSizeChanger: true,
                  locale: {
                    items_per_page: "Items / Page",
                  },
                  showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
                expandable={{
                  expandedRowRender: (record) => expandedRowRender(record),
                  onExpand: (expanded, record) => {
                    const index = dataSource.indexOf(record); // Calculate index based on the position of the record in the dataSource
                    handleExpand(expanded, record, index); // Pass index to handleExpand
                  },
                  expandedRowKeys,
                }}
              />
            {/* </Spin> */}
            </div>
          </div>
        </section>
 
    </>
  );
};

export default RfqPoConversionReport;
